import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "../ui/dropdown-menu";
import { Share2, MessageCircle, Mail, Copy } from "lucide-react";
import { toast } from "sonner";
import { buildConvocationMessage, buildParentEmails } from "./shareMessage";

export default function ShareConvocationMenu({ convocation, players, team, fields = [] }) {
  const message = buildConvocationMessage(convocation, players, team, fields);
  const parentEmails = buildParentEmails(convocation, players);

  const openWhatsApp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openEmail = () => {
    if (parentEmails.length === 0) {
      toast.error("Nessuna email genitori salvata per i convocati");
      return;
    }
    const subject = `Convocazione: ${convocation.title}`;
    // Use BCC so emails are not exposed to other recipients
    const url = `mailto:?bcc=${encodeURIComponent(parentEmails.join(","))}&subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;
    window.location.href = url;
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(message);
      toast.success("Testo copiato negli appunti");
    } catch {
      toast.error("Impossibile copiare");
    }
  };

  const useNativeShare = async () => {
    if (!navigator.share) {
      copyToClipboard();
      return;
    }
    try {
      await navigator.share({
        title: `Convocazione: ${convocation.title}`,
        text: message,
      });
    } catch (e) {
      // user cancelled or unsupported
      if (e && e.name !== "AbortError") {
        copyToClipboard();
      }
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="sm"
          variant="outline"
          data-testid={`share-convocation-${convocation.id}`}
        >
          <Share2 size={14} className="mr-1" /> Condividi
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuItem onClick={openWhatsApp} data-testid={`share-wa-${convocation.id}`}>
          <MessageCircle size={14} className="mr-2 text-emerald-600" /> WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem onClick={openEmail} data-testid={`share-email-${convocation.id}`}>
          <Mail size={14} className="mr-2 text-sky-600" /> Email genitori
          {parentEmails.length > 0 && (
            <span className="ml-auto text-xs text-slate-400">{parentEmails.length}</span>
          )}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={copyToClipboard} data-testid={`share-copy-${convocation.id}`}>
          <Copy size={14} className="mr-2 text-slate-500" /> Copia testo
        </DropdownMenuItem>
        {typeof navigator !== "undefined" && navigator.share && (
          <DropdownMenuItem onClick={useNativeShare}>
            <Share2 size={14} className="mr-2 text-slate-500" /> Altro...
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
